import { connect } from 'react-redux';
import CancelReservationAsDiv from './CancelReservationAsDiv';
import { fetchReservation, cancelReservation, closeCancelReservationScreen } from '../../actions/cancelling';
import { clearSession } from '../../actions/session';
import { resetBooking } from '../../actions/booking';

const mapStateToProps = state => ({
  userIdentified: state.session.userIdentified,
  fetchingReservationError: state.cancelling.fetchingReservationError,
  reservation: state.cancelling.reservation,
  cancellingReservationError: state.cancelling.cancellingReservationError,
  reservationCancelled: state.cancelling.reservationCancelled,
  resources: state.resources,
  units: state.units,
  reservationWasAlreadyCancelled: state.cancelling.reservationAlreadyCancelled,
  loginPolicyType: state.organization.loginPolicyType
});
const mapDispatchToProps = dispatch => ({
  closeCancelReservationScreen() {
    dispatch(closeCancelReservationScreen());
    dispatch(resetBooking());
  },
  fetchReservation: dispatch(fetchReservation),
  cancelReservation: dispatch(cancelReservation),
  logout: dispatch(clearSession)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelReservationAsDiv);



// WEBPACK FOOTER //
// ./src/containers/CancelReservationAsDiv/index.js